import { Route, RouteProps, Redirect } from "react-router";
import { GetCookie } from "./Utils/AppFunc";
export const PrivateRoute = ({ component: Component, layout: Layout, path: Path, ...rest }) => {

	var loggedInUser = GetCookie("user");
	console.log("loged user...", loggedInUser);
	if (loggedInUser == "" || !loggedInUser) {
		localStorage.clear();
    }

	let result = JSON.parse(localStorage.getItem("user"));

	return <Route
		{...rest}
		render={props =>
			result && result.email ? (
				<Layout>
					<Component {...props} />
				</Layout>
			) :
				(
					<Redirect to={{
						pathname: "/SignIn",
					}} />
				)
		}
	/>
}